import { find, first, keys, round } from 'lodash-es';
import { SizeOption, CustomPackagingOptionsMatrix } from '../types/featured-packaging';
import { LogisticsFeeRate } from '../types/store';

export function getSizeAsString(size: SizeOption, rotate?: boolean) {
  if (!size.width || !size.height) {
    return 'Custom Samples Available';
  }

  if (rotate) {
    return `${size.width}" x ${size.height}"`;
  }
  return `${size.height}" x ${size.width}"`;
}

export function getSizeOptions(packagingOptions: CustomPackagingOptionsMatrix, selectedType?: string): SizeOption[] {
  const types = keys(packagingOptions);
  const firstType: string = first(types);
  return packagingOptions[selectedType || firstType].sizes;
}

export function getQuantityOptions(
  packagingOptions: CustomPackagingOptionsMatrix,
  selectedType?: string,
  selectedSize?: string,
): { [key: string]: number } {
  const sizeOptions: SizeOption[] = getSizeOptions(packagingOptions, selectedType);
  return (find(sizeOptions, (option) => getSizeAsString(option) === selectedSize) || sizeOptions[0]).pricing;
}
// Only used currently for calculating display price (aka bundled price) for the featured
// packaging checkout flow.
export const calculateDisplayPrice = (price: number, logisticsFeeRateLadder: LogisticsFeeRate[]): number => {
  const logisticsFeeRate: LogisticsFeeRate = logisticsFeeRateLadder.find(
    (rate: LogisticsFeeRate) => price <= rate.ladder,
  );
  return round(price * (1 + logisticsFeeRate?.rate), 2);
};
